const posts = [
  {
    image: "/images/blog_cover2.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article1",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article2",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article3",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article4",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover3.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover4.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover5.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover6.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover7.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
  {
    image: "/images/blog_cover8.png",
    tag: "Тег",
    title: "Взыскание дебиторской задолжености",
    text: "Досье на человека — полная информация о конкретной личности, которую собирает частный детектив из различных источников. Документ может содержать сведения о трудовой деятельности, финансовом состоянии, здоровье, хобби, вредных привычках, семейных отношениях и о многих ...",
    date: "23.05.23",
    link: "/blog/article5",
  },
];

export default posts;
